import React, { useEffect, useState } from 'react';
import { ItemGroupForm } from '../../../Components/Form';
import FormLayout from '../../../Components/Layout/FormLayout';
import { NewItemIcon } from '../../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';

const AddItemGroups = ({ handleToast }) => {
  const { t } = useTranslation();
  const [, setStep] = useState(false);

  useEffect(() => {
    document.title = t('Items.item_groups');
  }, []);

  const handleStep = () => setStep(true);
  return (
    <FormLayout
      title={t('Items.item_groups')}
      Icon={NewItemIcon}
      closeUrl="/item-groups"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <ItemGroupForm
        type="add"
        title={t('Items.create_item_groups')}
        handleToast={handleToast}
        handleStep={handleStep}
      />
    </FormLayout>
  );
};

export default AddItemGroups;
